module.exports = "<strong>Search result for {{searchItems.searchTerm}}</strong><br>\r\n<div class=\"row\">\r\n    <div class=\"column col-12\">\r\n        <app-modulesearchresult *ngFor=\"let key of objectKeys(searchItems.results)\"\r\n                                [result]=\"searchItems.results[key]\"></app-modulesearchresult>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search/search.component.html
// module id = ./src/app/search/search/search.component.html
// module chunks = main